import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/coastal-dusk.css';

const DoNotSellPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen relative" style={{ background: '#1a1a1a' }}>
      <div className="landing-orb cool focus-shift" style={{ '--orb-opacity': '0.3', top: '-5%', left: '-5%', width: '45vw', height: '45vw', maxWidth: '500px', maxHeight: '500px' }} />
      <div className="landing-orb neutral" style={{ '--orb-opacity': '0.2', top: '55%', right: '-5%', width: '42vw', height: '42vw', maxWidth: '450px', maxHeight: '450px', animationDelay: '-4s' }} />

      <div className="max-w-2xl mx-auto px-6 sm:px-10 py-20 relative z-10">
        <button
          onClick={() => navigate(-1)}
          className="landing-ghost-link mb-10 block"
          style={{ fontSize: '0.82rem' }}
          data-testid="back-btn"
        >
          &larr; Back
        </button>

        <h1 className="text-display mb-2" style={{ fontSize: 'clamp(1.4rem, 4vw, 1.8rem)' }}>
          Do Not Sell or Share My Personal Information
        </h1>
        <p className="landing-step-body" style={{ color: 'var(--text-secondary)', fontSize: '0.82rem', marginBottom: '48px' }}>
          Effective Date: April 11, 2026 &middot; Contact: info@clarityjournalbyenquips.com
        </p>

        <p className="landing-step-body">
          Under the California Consumer Privacy Act (CCPA) and California Privacy Rights Act (CPRA), California 
          residents have the right to opt out of the sale or sharing of their personal information for cross-context 
          behavioral advertising.
        </p>

        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginTop: '32px', marginBottom: '12px' }}>
          What We Collect
        </h3>
        <p className="landing-step-body">
          Clarity Soundtrack collects only what is necessary to deliver your experience: journal entries (deleted 
          after processing), email address if provided, and payment information processed by third-party providers.
        </p>

        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginTop: '32px', marginBottom: '12px' }}>
          Do We Sell or Share Your Data?
        </h3>
        <p className="landing-step-body">
          We do not sell your personal information. If we use third-party analytics tools that qualify as "sharing" 
          under California's definition, this page gives you the right to opt out of that activity.
        </p>

        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginTop: '32px', marginBottom: '12px' }}>
          How to Opt Out
        </h3>
        <p className="landing-step-body">
          Email <a href="mailto:info@clarityjournalbyenquips.com" style={{ color: 'var(--accent-teal)', textDecoration: 'underline', textUnderlineOffset: '3px' }}>info@clarityjournalbyenquips.com</a> with 
          the subject line <span style={{ fontWeight: 400, color: 'var(--text-primary)' }}>Do Not Sell - Opt-Out Request</span>. 
          Include your name and email address. We will process your request within 15 business days and confirm by email.
        </p>

        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginTop: '32px', marginBottom: '12px' }}>
          Non-Discrimination
        </h3>
        <p className="landing-step-body">
          Opting out has no effect on your access to or use of Clarity Soundtrack.
        </p>

        <p className="landing-step-body" style={{ marginTop: '32px', color: 'var(--text-secondary)' }}>
          For access, correction, or deletion of your data, see our full <a href="/privacy" style={{ color: 'var(--accent-teal)', textDecoration: 'underline', textUnderlineOffset: '3px' }}>Privacy Policy</a> or contact us directly.
        </p>
      </div>
    </div>
  );
};

export default DoNotSellPage;
